import { IconButton } from '@material-ui/core';
import cx from 'classnames';

import { IconX } from 'src/assets/icons/IconX';
import { CustomButton } from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { FEATURE_LIMITS } from 'src/data/featureLimits';
import { useEffectOnce } from 'src/lib/hooks';
import { useCustomFeatureLimitsData } from 'src/store';

import { useTrackingEvents } from './services';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const PerformancePredictionsBanner = ({ className }) => {
  const styles = useStyles();

  const trackingEvents = useTrackingEvents();
  const { limit } = useCustomFeatureLimitsData(FEATURE_LIMITS.performancePredictions);
  const { handleClose, handleUpgrade } = useHandlers();

  useEffectOnce(() => {
    trackingEvents.trackBannerDisplayed();
  });

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.text}
        variant={TYPOGRAPHY_VARIANT.medium16}
      >
        You&apos;ve reached your limit of {limit} monthly performance predictions, but it&apos;s not
        too late to take the next step.
      </CustomTypography>

      <CustomButton
        className={styles.buttonUpgrade}
        onClick={handleUpgrade}
      >
        Upgrade
      </CustomButton>

      <IconButton
        className={styles.buttonClose}
        onClick={handleClose}
      >
        <IconX />
      </IconButton>
    </div>
  );
};
